import React, { SetStateAction } from 'react';

import Close from '@ast/magma/components/icon/icons/Times';

import { Modal, Button, Card } from '@ast/magma';

import { FlexContainer } from '@app/common/components/FlexContainer/FlexContainer';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';

import styles from './PasskeyModal.pcss';
import { useEscapeCloseHandler } from './useEscapeCloseHandler';

export const PasskeyModal = ({
  isVisible,
  setVisible,
}: { isVisible: boolean; setVisible: React.Dispatch<SetStateAction<boolean>> }) => {
  const { t } = useUserSettingsTranslation();

  useEscapeCloseHandler(() => setVisible(false));

  return isVisible ? (
    <Modal align="right" id="passkey-modal">
      <Card className={styles.modal}>
        <FlexContainer
          direction="column"
        >
          <div>
            <div className={styles.buttonContainer}>
              <Button
                data-stable-name="CloseIconButton"
                aria-label={t('profile-and-security.passkey-modal.close-button-icon|Close icon for passkey modal',
                  'Close icon for passkey modal')}
                predefinedSize="small"
                onClick={() => setVisible(false)}
                icon={<Close />}
                look="icon"
              />
            </div>

            <h6 className={styles.modalTitle}>{t('profile-and-security.passkey-modal.title|Passkey modal title', 'What is a Passkey?')}</h6>
          </div>

          <span className={styles.modalText}>{t('profile-and-security.passkey-modal.text-about|Passkey modal text about', 'A passkey is a secure, easy-to-use password replacement. Your passkeys are stored securely in a vault, such as your device’s keychain or your password manager. Passkeys can sync across devices, making them seamless and convenient to use.')}</span>
          <h6 className={styles.modalTitle}>{t('profile-and-security.passkey-modal.title-how|Passkey modal title how', 'How does it work?')}</h6>
          <span className={styles.modalText}>{t('profile-and-security.passkey-modal.text-how-work|Passkey modal text about', 'When you try to log in, we\'ll send a push notification to the smartphone you used when you registered the account. When you use your face, fingerprint, or PIN code to unlock the device, a unique passkey will be created and sent to our website. At this point, you will be logged in, all without your login information or biometric data needing to be typed out or transmitted.')}</span>
          <Button
            data-stable-name="CloseButton"
            aria-label={t('profile-and-security.passkey-modal.close-button-modal|Close passkey modal label',
              'Close passkey modal')}
            predefinedSize="small"
            onClick={() => setVisible(false)}
            look="outlined"
          >
            {t('profile-and-security.passkey-modal.close-button|Close passkey modal',
              'Close')}
          </Button>
        </FlexContainer>
      </Card>
    </Modal>
  ) : null;
};
